module.exports = __webpack_public_path__ + "media/images/previous-arrow-5a5cc240a57dcad0d490853bdf76d7c5.svg";